import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

export interface TimelineItem {
  title: string;
  description: string;
  date: string;
  iconStyles?: string;
}

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, MatButtonModule, MatCardModule, MatIconModule]
})

export class TimelineComponent {

  _timelineHeader?: string;
  _timelineItems?: TimelineItem[];

  @Input() set timelineHeader(value: string) {
    this._timelineHeader = value;
  }

  @Input() set timelineItems(value: TimelineItem[]) {
    this._timelineItems = value;
  }
}